import React, { useContext } from 'react';

import { AppServices } from 'rdx/middleware';

// we do not have default value
export const AppServicesContext = React.createContext<AppServices>({} as AppServices);

export const useAppServices = () => useContext(AppServicesContext);

interface AppServicesProps {
  appServices?: AppServices;
}

/**
 * @unused
 */
export const withAppServices = <P extends Record<string, unknown>>(
  WrappedComponent: React.ComponentType<P>,
): React.FC<P & AppServicesProps> => {
  return (props: Record<string, unknown>) => {
    return (
      <AppServicesContext.Consumer>
        {(value) => <WrappedComponent appServices={value} {...(props as P)} />}
      </AppServicesContext.Consumer>
    );
  };
};
